import { Component, Input, Renderer2, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { MastersService } from '../../masters.service'
import { ResponseModel } from '../../../../../shared/models/response-model.model';
import { catchError } from 'rxjs';
import { MasterModalTitle, BranchMainModel, CreateUpdateBranchRequestModel, CloneDataModel } from '../../masters.model';
import { StorageService } from '../../../../../shared/services/storage.service';
import { StorageName } from '../../../../../shared/enum/common-enum';
import { LayoutDetails } from '../../../../../auth/auth.model';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { IconHover } from '../../../../../shared/enum/common-enum';

@Component({
  selector: 'app-branch-details',
  templateUrl: './branch-details.component.html',
  styleUrls: ['./branch-details.component.scss'],
  
})
export class BranchDetailsComponent extends CommonService{
  currentHoverEffect = IconHover.Pink;
  @Input() editBranchDetails: any;
  @Input() modalTitle       : string;
  @Input() data             : any;
  @Input() getAllDropdownModel : any = {};
  masterModalTitle = MasterModalTitle;
  @ViewChild("AddEditBranchForm") AddEditBranchForm!: NgForm;
  createUpdateBranchRequestModel = new CreateUpdateBranchRequestModel();
  cloneDataModel                 = new CloneDataModel();
  branchMainModel = new BranchMainModel();
  getDistrictData : any[]=[];
  getTalukaData : any[]=[];
  storageName=StorageName;
  public selectedTabs: string[] = []; 
  public cloneTableNames: string[] = [];
  layoutDetails= new LayoutDetails();
  filterCountryWise: any; 
  constructor(
    public activeModal: NgbActiveModal,
    public renderer: Renderer2,
    public mastersService: MastersService,
    public toaster: ToastrService,
    public storageService:StorageService ,
    public sendDataService:SendDataService ,
  ) {
    super(renderer);
  }
  
  ngOnInit() {
    this.layoutDetails =this.storageService.retrieve(StorageName.LAYOUT_DETAILS);
  }

  fillDropdownData(){
    this.getAllDropdownModel.countryDropdown = this.storageService.retrieve(StorageName.COUNTRY_DROPDOWN);
    this.getAllDropdownModel.stateDropdown = this.storageService.retrieve(StorageName.STATE_DROPDOWN);
    this.getAllDropdownModel.districtDropdown = this.storageService.retrieve(StorageName.DISTRICT_DROPDOWN);
    this.getAllDropdownModel.talukaDropdown  = this.storageService.retrieve(StorageName.TALUKA_DROPDOWN);
    this.getAllDropdownModel.mastersDropdown  = this.storageService.retrieve(StorageName.MASTERS_DROPDOWN);
    
    if (this.data?.editBranchDetails?.id) {
      this.createUpdateBranchRequestModel = this.data?.editBranchDetails;
      const countryId = this.getCountryId(this.data?.editBranchDetails?.stateId);
      this.createUpdateBranchRequestModel.countryId = countryId;
      this.onChangeCountryName(this.createUpdateBranchRequestModel?.countryId)
    } else {
      const countryId = this.getCountryId(this.layoutDetails?.stateId);
      this.createUpdateBranchRequestModel.countryId = countryId;
      this.createUpdateBranchRequestModel.stateId = this.layoutDetails?.stateId;
      this.onChangeCountryName(this.createUpdateBranchRequestModel?.countryId)
    }
  }

  getCountryId(stateId){
    return this.getAllDropdownModel?.stateDropdown?.find((x)=>x?.id == stateId)?.extra1;
  }

  addEditBranch() {
    if(!(this.createUpdateBranchRequestModel?.id? this.sendDataService?.permissionVM?.mastersCanUpdate : this.sendDataService?.permissionVM?.mastersCanAdd)) return;
    if (this.AddEditBranchForm?.valid) {
      if (this.data?.editBranchDetails?.id) {
        this.updateBranch();
      } else {
        this.createBranch();
      }
    }
  }

  prepareBranchModel(): boolean {
    const model = this.createUpdateBranchRequestModel;

    if ((model?.mobileNumber1 && !model?.mobileNo1DialCode) || (model?.mobileNumber2 && !model?.mobileNo2DialCode)) {
      this.toaster.error('Please enter country code for Mobile Number.');
      return false;
    }
    if ((!model?.mobileNumber1 && model?.mobileNo1DialCode) || (!model.mobileNumber2 && model?.mobileNo2DialCode)) {
      this.toaster.error('Please enter Mobile Number for country code.');
      return false;
    }
    if (!model?.mobileNumber1 && !model?.mobileNo1DialCode) {
      model.mobileNumber1 = null;
      model.mobileNo1DialCode = null;
    }
    if (!model?.mobileNumber2 && !model?.mobileNo2DialCode) {
      model.mobileNumber2 = null;
      model.mobileNo2DialCode = null;
    }
    return true;
  }
  
  createBranch() {
    if (!this.prepareBranchModel()) return;
    this.branchMainModel.branchModel = this.createUpdateBranchRequestModel;
    this.branchMainModel.cloneDataModel = this.cloneDataModel;
    this.branchMainModel.cloneDataModel.cloneTableNames = this.cloneTableNames;
  
    this.mastersService?.insertBranch(this.branchMainModel)
      .pipe(catchError((err) => this.handleError(err)))
      .subscribe((res: ResponseModel) => {
        if (res?.isSuccess) {
          this.activeModal.close(res?.isSuccess);
          this.toaster.success(res?.message);
        } else {
          this.toaster.error(res?.errors[0]);
        }
      });
  }
  
  updateBranch() {
    if (!this.prepareBranchModel()) return;
    this.branchMainModel.branchModel = this.createUpdateBranchRequestModel;
    this.mastersService.updateBranch(this.branchMainModel).pipe(catchError((err) => this.handleError(err)))
      .subscribe((res: ResponseModel) => {
        if (res?.isSuccess) {
          const updatedBranch = {
            id: this.branchMainModel?.branchModel?.id,
            name: this.branchMainModel?.branchModel?.name
          };
          this.mastersService.BranchUpdated.emit(updatedBranch)
          this.activeModal.close(res?.isSuccess);
          this.toaster.success(res?.message);
        } else {
          this.toaster.error(res?.errors[0]);
        }
      });
  }

  onChangeCountryName(id){
    this.filterCountryWise = this.getAllDropdownModel?.stateDropdown?.filter((x)=>x?.extra1 == id);
  }

      selectTab(tabName: string, ExtraTab: any): void {
        const extraTabArray = ExtraTab.split(',').map(item => item.trim());
        const tabsArray = [tabName, ...extraTabArray]?.filter(item => item !== '');
        const index = this.selectedTabs.indexOf(tabName);

        if (index === -1) {
            this.selectedTabs.push(...tabsArray);
            this.cloneTableNames.push(...tabsArray);
        } else {
            this.selectedTabs.splice(index, tabsArray.length);
            this.cloneTableNames.splice(index, tabsArray.length);
        }
    }
    
    ResetBranchDetails(){
      this.createUpdateBranchRequestModel  = new CreateUpdateBranchRequestModel();
      this.cloneDataModel                 = new CloneDataModel();
      this.cloneTableNames =[];
      this.selectedTabs =[];
      
    }
    
}
